import React, { useState } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import { DialogMain, IconButtonMain } from "./styles/DialogStyles";
import CloseIcon from "@mui/icons-material/Close";
import SelectDropDown from "../shared/SelectDropDown";
import MainButton from "../../shared/Button";
import DateInput from "../shared/DateInput";
import SelectedJobsPopup from "./SelectedJobsPopup";

const GenerateInvoicesPopup = ({ open, handleClose }) => {
  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    // Perform any desired actions with the selected option
  };

  const [openDialog, setOpenDialog] = useState(false);

  const OpenAndClosehandle = () => {
    setOpenDialog(true);
    handleClose();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6>Select date range to generate invoices</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <label>Customer Name</label>
          <SelectDropDown
            options={options}
            selectedOption={selectedOption}
            handleChange={handleChange}
          />
          <DateInput label="Start Date" ButtonText=" Select start date" />
          <DateInput label="End Date" ButtonText=" Select end date" />

          <MainButton
            type="button"
            label="Generate Invoices"
            MT="50"
            onClick={OpenAndClosehandle}
          />
        </DialogContent>
      </DialogMain>
      <SelectedJobsPopup open={openDialog} handleClose={handleCloseDialog} />
    </>
  );
};

export default GenerateInvoicesPopup;
